import { Component, OnInit, Input } from '@angular/core';
import { CaseService } from 'src/app/shared/services/case.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { KeyDatesService } from 'src/app/shared/services/keydates.service';
import { CorrespondenceTimelineService } from '../../../../shared/services/correspondence-timeline.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-key-date',
  templateUrl: './delete-key-date.component.html',
  styleUrls: ['./delete-key-date.component.scss']
})
export class DeleteKeyDateComponent implements OnInit {

  @Input() caseId?: number;
  @Input() keyDateTypeId?: number;
  @Input() keyDateId: number;
  @Input() keyDateName?: string;
  @Input() keyDateValue?: any;

  private notes: string = '';


  isLoading: boolean = false;

  deleteKeyDateDetails= new UntypedFormGroup({
    reason: new UntypedFormControl()
  });

  constructor( public activeModal: NgbActiveModal,
  private caseService: CaseService,
  private keyDatesService: KeyDatesService,
  private correspondenceTimelineService: CorrespondenceTimelineService) {

  }

  ngOnInit(): void {
  }

  cancel(){
    this.activeModal.dismiss(null);
  }


  deleteKeyEvent(){

    this.isLoading = true;

    this.keyDatesService.deleteKeyDate(this.keyDateId, this.deleteKeyDateDetails.value).subscribe(response => {
      this.correspondenceTimelineService.refreshCaseTimeline.next();

      this.activeModal.close(true);

      }, (error : any ) => {

        var errorMessage = "Deleting Key Event Failed";

        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }
      });
  }
}
